export const CUSTOMERS_ROUTES = {
  ROOT: "customers",
  NEW: "new",
  DETAIL: ":customerId",
  GROUP: "group/:groupType",
} as const;

export const CUSTOMERS_GROUP_TYPE = {
  FAVORITES: "favorites",
  OFFERS: "offers",
} as const;

export type CustomersGroupType =
  (typeof CUSTOMERS_GROUP_TYPE)[keyof typeof CUSTOMERS_GROUP_TYPE];
